import { Link, Outlet, useNavigate, useSearchParams } from "react-router";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import LogoText from "@/components/logo/LogoText";
import { useAppSelector } from "@/hooks/redux-hooks";
import { useEffect } from "react";

export default function AuthLayout() {
  const navigate = useNavigate();
  const { isAuthenticated, user, authState } = useAppSelector(
    (state) => state.auth
  );
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (authState === "authenticated") {
      const nextPage = searchParams.get("nextPage");
      if (nextPage) navigate(nextPage);
      else navigate("/overview");
    }
  }, [isAuthenticated, user, searchParams, authState]);

  return (
    <>
      <div className="flex flex-col">
        <div className="mt-8 font-bold text-4xl relative z-[65757657567] px-28 flex items-center space-x-1">
          <Link to="/">
            <LogoText />
          </Link>
        </div>
        <div className="flex justify-center items-center h-[80vh]">
          <Card className="w-full h-full m-auto !shadow-sm">
            <div className="absolute inset-0 bg-background">
              <div
                className="absolute w-full h-[300px] bg-primary rounded-full blur-3xl opacity-40"
                style={{ top: "40%", left: "30%" }}
              ></div>
            </div>

            <div className="relative flex items-center w-full h-full m-auto px-20 py-10 overflow-hidden">
              <motion.div
                className="flex-1 p-8 md:p-12"
                initial={{ opacity: 0, x: -200 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h1 className="text-4xl text-primary font-bold mb-6">
                  Streamlined <br /> Financial Transactions.
                </h1>
                <div className="space-y-6">
                  <div>
                    <h2 className="text-xl font-semibold">
                      Simplified Tier Management
                    </h2>
                    <p className="text-sm mt-2">
                      Simplified Onboarding. Flexible Transaction Management.
                      From customer onboarding to advanced transaction
                      processing,
                      <br /> Nettpay transforms complex financial workflows into
                      seamless, efficient operations.
                    </p>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold">
                      Centralized Service Management
                    </h2>
                    <p className="text-sm mt-2">
                      Monitor transactions, manage customers, and configure
                      services with ease—all from a single, intuitive platform
                      designed for optimal control.
                    </p>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold">
                      Integrated virtual account Solutions
                    </h2>
                    <p className="text-sm mt-2">
                      Effortlessly manage internal and external virtual account
                      with our standardized protocol, ensuring seamless
                      integration and secure transactions across your business
                      ecosystem.
                    </p>
                  </div>
                </div>
              </motion.div>

              <Outlet />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
